import React from "react";
import ReactDOM from "react-dom/client";
import "./CSS/App.scss";
import {
  BackToTopBtn,
  Gallery,
  Footer,
  Home,
  Navigation,
  NotFoundPage,
  PrivacyPolicy,
  TermsOfUse,
  Reservation,
} from "./Components";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Navigation />
    <BackToTopBtn />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/galerija" element={<Gallery />} />
      <Route path="/rezervacija" element={<Reservation />} />
      {/* ERRORS */}
      <Route path="*" element={<NotFoundPage />} />
      {/* PRIVACY POLICY */}
      <Route path="/politika-privatnosti" element={<PrivacyPolicy />} />
      <Route path="/uvjeti-korištenja" element={<TermsOfUse />} />
    </Routes>
    <Footer />
  </BrowserRouter>
);
